<div class="container-fluid">
    <app-page-title title="Coupon"
        [breadcrumbItems]="breadCrumbItems"></app-page-title>

    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <ul ngbNav #justifiednavpills="ngbNav" [activeId]="1"
                        class="nav-pills nav-justified bg-light">
                        <li [ngbNavItem]="1" (click)="setBreadCrumb('General')">
                            <a ngbNavLink>
                                <span>General</span>
                            </a>
                            <ng-template ngbNavContent>
                                <app-coupon-general [couponList]="couponList"
                                    [currentCouponType]="currentCouponType"></app-coupon-general>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="2" (click)="setBreadCrumb('Segment')">
                            <a ngbNavLink>
                                <span>Segment</span>
                            </a>
                            <ng-template ngbNavContent>
                                <app-coupon-segment [couponList]="couponList"
                                    [currentCouponType]="'segment'"></app-coupon-segment>
                            </ng-template>
                        </li>

                    </ul>

                    <div [ngbNavOutlet]="justifiednavpills"></div>
                </div>
            </div>
        </div>
    </div>
</div>